import { render, staticRenderFns } from "./ModalExclusaoUser.vue?vue&type=template&id=df79c8a0&scoped=true&"
import script from "./ModalExclusaoUser.vue?vue&type=script&lang=js&"
export * from "./ModalExclusaoUser.vue?vue&type=script&lang=js&"
import style0 from "./ModalExclusaoUser.vue?vue&type=style&index=0&id=df79c8a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df79c8a0",
  null
  
)

export default component.exports